import {DestroyRef, inject, Injectable, OnDestroy} from '@angular/core';
import {RestServiceAbstract} from '../../../abstracts/rest-service.abstract';
import {catchError, map, takeUntil} from 'rxjs/operators';
import {Subject, throwError} from 'rxjs';
import {ResponseSnakeModel} from '../../../models/response-snake.model';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Injectable({
    providedIn: 'root',
})
export class DialogsRestService extends RestServiceAbstract implements OnDestroy {
    protected ngUnsubscribe$: Subject<void> = new Subject<void>();
    protected destroyRef = inject(DestroyRef);

    public loadAllDialogs(page, size, filter: string, type: string, sort: any, company?, location?, status?) {
        return this.get(`/cms/admin/dialogs`, {
            params: {
                search: filter,
                page: page,
                size: size,
                sort: `${sort.field},${sort.direction}`,
                company: company,
                location: location,
                status: status,
                type: type
            }
        }).pipe(
            takeUntilDestroyed(this.destroyRef),
            map(data => {
                return new ResponseSnakeModel(data);
            }),
            catchError(err => {
                console.error('❌ Error loading dialogs:', err);
                throw err;
            })
        );
    }


    getForDate(start, end) {
        return this.get('/cms/admin/ads/date', {params: {start: start, end: end}})
            .pipe(takeUntil(this.ngUnsubscribe$),
                map(data => {
                    return new ResponseSnakeModel(data);
                })
            );
    }

    getCurrentAds(idf: string) {
        return this.get('/cms/ads', {params: {idf: idf}})
            .pipe(takeUntil(this.ngUnsubscribe$),
                map(data => {
                    return new ResponseSnakeModel(data);
                })
            );
    }

    saveAd(ad) {
        return this.post('/cms/admin/ads', ad).pipe(takeUntil(this.ngUnsubscribe$),
            map(data => {
                return new ResponseSnakeModel(data);
            }));
    }

    deleteAd(id) {
        return this.delete('/cms/admin/ads/' + id, {id: id})
            .pipe(takeUntil(this.ngUnsubscribe$),
                map(data => {
                    return new ResponseSnakeModel(data);
                })
            );
    }

    /**
     * Unsubscribe from all subscriptions.
     */
    ngOnDestroy(): void {
        // This aborts all HTTP requests.
        this.ngUnsubscribe$.next();
        // This completes the subject properly.
        this.ngUnsubscribe$.complete();
    }

    getSupplierAds(s: string, vendor: number) {
        return this.get('/cms/admin/ads/supplier', {params: {search: s, vendor: vendor}})
            .pipe(takeUntil(this.ngUnsubscribe$),
                map(data => {
                    return new ResponseSnakeModel(data);
                })
            );
    }

    getSupplierAdsForDate(start, end) {
        return this.get('/cms/admin/ads/date/supplier', {params: {start: start, end: end}})
            .pipe(takeUntil(this.ngUnsubscribe$),
                map(data => {
                    return new ResponseSnakeModel(data);
                })
            );
    }
}
